export const enum EDocumentType {
    BOOK = 'BOOK',
    REPORT = 'REPORT',
    BENCHMARK = 'BENCHMARK',
    TREND = 'TREND',
    OTHER = 'OTHER',
}
